import type * as Types from '../codegen/graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetReleaseCommitQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetReleaseCommitQuery = { __typename?: 'Query', releaseCommit: string };


export const GetReleaseCommitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReleaseCommit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseCommit"}}]}}]} as unknown as DocumentNode<GetReleaseCommitQuery, GetReleaseCommitQueryVariables>;